import React from 'react'
import ReactDOM from 'react-dom'
import {CookiesProvider} from 'react-cookie'
import {Provider} from 'react-redux'
import {createBrowserHistory} from 'history'
import {store} from '_helpers/store'
import { logger } from "./_helpers/logger";


import 'assets/scss/material-dashboard-pro-react.css?v=1.4.0'
import "react-vis/dist/style.css"

import { unregister } from './registerServiceWorker'

import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en.json'
import nl from 'javascript-time-ago/locale/nl.json'
import fr from 'javascript-time-ago/locale/fr.json'
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore, Log } from 'oidc-client-ts';
import App from './App'

// Enable debug logging for oidc-client
// Log.setLevel(LOG_LEVELS[window.REACT_APP_LOG_LEVEL]);
// Log.setLogger(logger);

TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(nl)
TimeAgo.addLocale(fr)

export const history = createBrowserHistory();
export var api_root = '/api';
if (process.env.NODE_ENV === "development") {
  api_root = 'http://' + window.location.hostname + ':5001/api';
}

function handleLogin(e) {
  logger.log("logged in via external page", e)
}

const oidcConfig = {
  onSigninCallback: () => handleLogin,
  authority: `${window.REACT_APP_AUTHORITY}${window.REACT_APP_USER_POOL_ID}`,
  client_id: window.REACT_APP_CLIENT_ID,
  redirect_uri: window.REACT_APP_REDIRECT,
  response_type: 'code',
  scope: "openid email aws.cognito.signin.user.admin",
  silent_redirect_uri: `${window.location.origin}/auth/silent-callback.html`,
  automaticSilentRenew: false, // We'll handle this manually with a simpler approach
  loadUserInfo: true,
  extraHeaders: {'Access-Allow-Cross-Origin': '*'},
  showDebugInformation: false,
  post_logout_redirect_uri: window.REACT_APP_REDIRECT,
  // Store tokens in localStorage instead of sessionStorage for persistence
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}


ReactDOM.render(
  <AuthProvider {...oidcConfig}>
    <CookiesProvider>
      <Provider store={store}>
        <App/>
      </Provider>
    </CookiesProvider>
  </AuthProvider>,
  document.getElementById('root')
);

unregister();
